import { useState } from "react";
import { ButtonProps, useRecordContext } from "react-admin";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import Button from '@mui/material/Button';

import { ToolbarStyledButton } from './ToolbarButton';
import { apiRoutes, fetchJson } from "@/src/services";

const sendEmail = async (topic: string, userId: string, data: any) => {
    const resp = await fetchJson(`${apiRoutes.sendEmail}/${topic}/${userId}`, { method: 'POST', mode: 'cors', body: JSON.stringify(data) })
    console.log(resp)
    return resp;
}


export const SendMailButton = (props: ButtonProps) => {
    const record = useRecordContext(props);   
    const [open, setOpen] = useState<boolean>(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOpen(true);
    };

    const [template, setTemplate] = useState("");
    const handleChange = (event: any) => {
        setTemplate(event.target.value);
    };

    const handleSendEmail = async () => {
        try {
            if (record) {
                const userId = record.id.toString();
                switch (template) {
                    case "registration-verify":
                        await sendEmail(template, userId, { verification: record.verification });
                        break;
                    case "reset-password":
                    case "new-messages":
                    case "new-visitors":
                        alert("no message was sent");
                        break;
                    default:
                        await sendEmail(template, userId, record);
                        break;

                }


            }
        } catch (err) {
            console.log(err);
        };
        // setSelectedIndex(index);
        setOpen(false);
    }

    return (
        <>
            {/* <RaButton label="Email" onClick={handleClick} size='small' variant="outlined" color="primary">
                <EmailIcon /> */}
            {/* //{...sanitizeRestProps(props)} /> */}
            {/* </RaButton> */}
            <ToolbarStyledButton onClick={handleClick} label="Email" {...props}>
                <EmailIcon /> 
            </ToolbarStyledButton >
            <Dialog open={open}>
                <DialogTitle>Choose template</DialogTitle>
                <DialogContent>
                    <TextField label="Template" placeholder="Type or select template" value={template} />
                    <RadioGroup name="template" value={template} onChange={handleChange}>
                        <FormControlLabel value="registration-verify" control={<Radio />} label="registration-verify" />
                        <FormControlLabel value="reset-password" disabled={true} control={<Radio />} label="reset-password" />
                        <FormControlLabel value="new-messages" disabled={true} control={<Radio />} label="new-messages" />
                        <FormControlLabel value="new-visitors" disabled={true} control={<Radio />} label="new-visitors" />
                        <FormControlLabel value="test1" control={<Radio />} label="test1" />
                        <FormControlLabel value="template1" control={<Radio />} label="template1" />
                        <FormControlLabel value="template2" control={<Radio />} label="template2" />
                        <FormControlLabel value="template3" control={<Radio />} label="template3" />

                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">Cancel</Button>
                    <Button onClick={handleSendEmail} color="primary">Send</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

// const sanitizeRestProps = ({
//     basePath,
//     // classes,
//     filterValues,
//     // label,
//     selectedIds,
//     ...rest
// }: Omit<BulkActionProps, 'resource' | 'icon'>) => rest;
